import Image from "next/image";
import {LeonCompanyMain} from "../../data/StaticImages";

interface HeaderImageWithHeadingProps {
	title?: string;
	subtitle?: string;
	subtitle2?: string;
	imageSrc?: string;
	hideBackdropFade?: boolean;
}

function HeaderImageWithHeading(props: HeaderImageWithHeadingProps) {
	const title = props.title ?? "";
	const subtitle = props.subtitle ?? "";
	const subtitle2 = props.subtitle2 ?? "";
	const src = props.imageSrc ?? LeonCompanyMain;
	const hideBackdropFade = props.hideBackdropFade ?? true;

	return (
		<div className="h-[440px] md:h-[640px] object-fill overflow-hidden relative">
			{src !== "" && (
				<Image
					quality={90}
					alt="Leon Inmobiliaria"
					src={src}
					fill
					className="w-full object-cover "
				/>
			)}
			{!hideBackdropFade && (
				<div className="absolute w-full h-full bg-gradient-to-t from-[rgba(0,0,0,0.8)] via-40% via-[rgba(0,0,0,0.7)] to-transparent"></div>
			)}
			<div className="absolute bottom-8 md:bottom-32 left-6 right-6 md:left-20 text-white space-y-4 max-w-[800px]">
				{title !== "" && <h1 className="">{title}</h1>}
				{title !== "" && <p className="hidden md:block">{subtitle}</p>}
				{title !== "" && <p className="hidden md:block">{subtitle2}</p>}
			</div>
		</div>
	);
}

export default HeaderImageWithHeading;
